  class ChatWidget {
    constructor() {
      // DOM Elements
      this.container = document.getElementById('cw-container');
      this.tooltip = document.getElementById('cw-tooltip');
      this.closeTooltipBtn = document.getElementById('cw-close-tooltip');
      this.window = document.getElementById('cw-window');
      this.closeWindowBtn = document.getElementById('cw-close-window');
      this.fab = document.getElementById('cw-fab');
      this.successOverlay = document.getElementById('cw-success');

      // Configuration
      this.storageKey = 'chatWidget_tooltip_hidden_until';
      this.hideDurationDays = 2; // Hide for 2 days when manually closed
      this.isOpen = false;

      // Initialize
      if (this.container) {
        this.init();
      }
    }

    init() {
      this.checkTooltipStatus();
      this.bindEvents();
    }

    checkTooltipStatus() {
      const hiddenUntil = localStorage.getItem(this.storageKey);
      const now = new Date().getTime();

      if (hiddenUntil && now < parseInt(hiddenUntil, 10)) {
        // Don't show tooltip if still within the hidden duration
        return;
      }

      // Delay showing the tooltip slightly for better UX
      setTimeout(() => {
        if (!this.isOpen) {
          this.tooltip.classList.add('cw-visible');
        }
      }, 1500);
    }

    bindEvents() {
      // Toggle chat window on FAB click
      this.fab.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleWindow();
      });

      // Close tooltip manually
      this.closeTooltipBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.dismissTooltip();
      });

      // Close window via header 'X'
      this.closeWindowBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeWindow();
      });

      // Close window when clicking outside the widget
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.container.contains(e.target)) {
          this.closeWindow();
        }
      });
    }

    dismissTooltip() {
      this.tooltip.classList.remove('cw-visible');

      // Set expiry in localStorage (Current time + 2 days in milliseconds)
      const expiryTime = new Date().getTime() + this.hideDurationDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.storageKey, expiryTime.toString());
    }

    toggleWindow() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.window.classList.add('cw-open');
        this.tooltip.classList.remove('cw-visible');
      } else {
        this.closeWindow();
      }
    }

    closeWindow() {
        this.isOpen = false;
        this.window.classList.remove('cw-open');
        setTimeout(() => {
        if (this.successOverlay) {
            this.successOverlay.classList.remove('cw-active');
        }
        }, 300);
    }

    /**
     * Triggers the success message and closes the window shortly after.
     * Note: Call this method externally when the form submits.
     */
    triggerSuccess() {
      this.successOverlay.classList.add('cw-active');

      // Hide success and close window after 4 seconds
      setTimeout(() => {
        this.closeWindow();
        setTimeout(() => {
          this.successOverlay.classList.remove('cw-active');
        }, 300); // Wait for window close animation to finish
      }, 4000);
    }
  }

  // Initialize the widget once the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', () => {
    // Expose it to the window object so you can trigger success externally
    window.myChatWidget = new ChatWidget();
  });